import { Product } from '@/domains/direct-sales/const/product.const'

export const msProducts = [
  {
    label: 'form.products.multilife',
    value: Product.MULTILIFE,
  },
  {
    label: 'form.products.multisport',
    value: Product.MULTISPORT,
  },
  {
    label: 'form.products.mybenefit',
    value: Product.MYBENEFIT,
  },
  {
    label: 'form.products.wellbeing',
    value: Product.WELLBEING,
  },
]

export const EUIFormVariant = {
  Base: 'base',
  Products: 'products',
} as const

export type EUIFormVariant = typeof EUIFormVariant[keyof typeof EUIFormVariant]

export const EUiFormCountry = {
  POLAND: 'PL',
  OTHER: 'Other',
} as const

export type EUiFormCountry = typeof EUiFormCountry[keyof typeof EUiFormCountry]

export const EUiFormColor = {
  WHITE: 'white',
  GRAY: 'gray',
  LIGHT_BLUE: 'light-blue-100',
  PSYCHOLOGY: 'psychology',
  PURPLE: 'purple',
} as const

export type EUiFormColor = typeof EUiFormColor[keyof typeof EUiFormColor]
